<!-- BackgroundImage -->
<img class="absolute left-0 top-0 z-0 h-full w-full object-cover blur" [src]="src()" alt="">
<div class="absolute left-0 top-0 z-0 h-full w-full bg-black/50"></div>
<!-- Image -->
<img class="relative z-0 h-full w-auto" [class]="placeholder() ? 'object-cover' : 'max-w-full object-contain'" [src]="src()" [alt]="alt()">
